import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { useDynamicFormsTranslate } from "@ryde/redux";
import {
  getRegisterAttributes,
  ICustomField,
  switchAnyValueToBool,
} from "@ryde/shared";

import { FullWidthTextFieldWrapper } from "../parts-styled";
import { FieldExplanationIcon } from "./_parts";

export const CheckboxTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  labelTranslated,
  formAttributes,
  e2eData = "checkbox-template",
}) => {
  const { control } = useFormContext();

  const { disabled } = getRegisterAttributes(formAttributes);
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
    translatedText: labelTranslated,
  });
  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({
          field: { value: checkedValue, onChange, ...rest },
          fieldState: { error },
        }) => (
          <FormGroup data-e2e-template="checkbox-template">
            <FormControlLabel
              data-e2e={e2eData}
              {...rest}
              control={
                <Checkbox
                  onChange={onChange}
                  value={switchAnyValueToBool(checkedValue)}
                  disabled={disabled}
                  onClick={e => e.stopPropagation()}
                />
              }
              label={!formAttributes?.noLabel ? formLabelTranslated : ""}
              onClick={e => e.preventDefault()}
            />
            {/*TODO: add translation solution*/}
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormGroup>
        )}
      />
      <FieldExplanationIcon formAttributes={formAttributes} />
    </FullWidthTextFieldWrapper>
  );
};
